import { t } from 'i18next';

import type { TwoFactorCodeErrorType } from './Errors';

import { TwoFactorCodeError } from './Errors';

/** True when the value is a full authenticator code or looks like a recovery code. */
export function isCompleteTwoFactorCode(value: string): boolean {
	const trimmed = value.trim();
	return /^\d{6}$/.test(trimmed) || trimmed.replace(/[^a-z0-9]/gi, '').length >= 10;
}

/** The translated message for a rejected code. */
export function twoFactorErrorMessage(type: TwoFactorCodeErrorType): string {
	switch (type) {
		case 'INVALID_CODE':
			return t('twoFactor.errors.invalidCode');
		case 'TOO_MANY_ATTEMPTS':
			return t('twoFactor.errors.tooManyAttempts');
		case 'EXPIRED':
			return t('twoFactor.errors.expired');
		default:
			return t('common.error');
	}
}

/** The message to show for a failed request that took a two-factor code. */
export function twoFactorRequestErrorMessage(error: unknown): string {
	const message = (error as { response?: { data?: { message?: string } } } | undefined)?.response?.data?.message;
	if (message === 'auth.two.factor.invalid.password') {
		return t('twoFactor.errors.invalidPassword');
	}
	return twoFactorErrorMessage(TwoFactorCodeError.fromResponse(error).type);
}
